import { render, staticRenderFns } from "./SheetPackages.vue?vue&type=template&id=2852aeae&scoped=true"
import script from "./SheetPackages.vue?vue&type=script&lang=js"
export * from "./SheetPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852aeae",
  null
  
)

export default component.exports